module.exports = __webpack_public_path__ + "static/media/Spin-1s-200px.968bc98a.gif";